module.exports = __webpack_public_path__ + "static/media/55.ebd5c4d6.jpg";